import React from 'react';

let ShoresideInstructionContext: React.Context<string>;
export class ShoresideInstructionGetter {
    public shoresideInstruction: any;
    public async getShoresideInstruction() {
        this.shoresideInstruction = await fetch('assets/shoreside-instructions.txt').then((r) => r.text());
        ShoresideInstructionContext = React.createContext(this.shoresideInstruction);
        return this.shoresideInstruction;
    }
}

const getShoresideInstructionContext = function () {
    return ShoresideInstructionContext;
};
export default getShoresideInstructionContext;
